import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const data = [
  { time: '5h30', 'condition 1': 0.544, 'condition 2': 0.506, 'condition 3': 0.426, 'condition 4': 0.354, 'condition 5': 0.364, 'condition 6': 0.300 },
  { time: '6h05', 'condition 1': 0.570, 'condition 2': 0.494, 'condition 3': 0.458, 'condition 4': 0.393, 'condition 5': 0.402, 'condition 6': 0.332 },
  { time: '7h40', 'condition 1': 0.642, 'condition 2': 0.533, 'condition 3': 0.473, 'condition 4': 0.384, 'condition 5': 0.417, 'condition 6': 0.382 },
  { time: '10h', 'condition 1': 0.644, 'condition 2': 0.567, 'condition 3': 0.580, 'condition 4': 0.481, 'condition 5': 0.556, 'condition 6': 0.437 },
];

function Figure6() {
  return (
    <div>
      <br></br>
      <p> <u>Figure 6: Culture OD evolution over time </u></p>
      <LineChart width={600} height={300} data={data} margin={{ top: 20, right: 30, left: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="time" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line type="monotone" dataKey="condition 1" stroke="blue" />
        <Line type="monotone" dataKey="condition 2" stroke="red" />
        <Line type="monotone" dataKey="condition 3" stroke="green" />
        <Line type="monotone" dataKey="condition 4" stroke="violet" />
        <Line type="monotone" dataKey="condition 5" stroke="pink" />
        <Line type="monotone" dataKey="condition 6" stroke="grey" />
      </LineChart>
    </div>
  );
}

export default Figure6;